import { PAGINATED_GALLERY_ROUTE_NAMES } from '../constants'
import { PaginatedGalleryRoute } from '../types'

export const isPaginatedGalleryRouteName = (
  name: string,
): name is PaginatedGalleryRoute =>
  (PAGINATED_GALLERY_ROUTE_NAMES as string[]).includes(name)
